<template>
  <CFooter :fixed="false">
    <div>
      <a href="#" target="_blank">An nam</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} - {{new Date().getFullYear() + 1}} creativeLabs.</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="#" target="_blank">Team An Nam</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
